import React from 'react';
import {
	Filter,
	ReferenceInput,
	SelectInput,
} from 'admin-on-rest';
import { getFirstDealership, yearNow, monthNow } from '../util'

const currentYear = (new Date()).getFullYear()
const years = []
for ( var i = currentYear; i >= 2017; i-- ) {
	years.push({
		id: i.toString(),
		name: i,
	})
}

// <TextInput label="Search" source="q" />
export default (props) => (
    <Filter {...props}>
		<ReferenceInput label="Dealership" source="dealership" reference="dealerships" translateChoice={false}>
			<SelectInput/>
		</ReferenceInput>
		<SelectInput label="Year" source="year" translateChoice={false} choices={[
			...years,
		]} alwaysOn defaultValue={ yearNow() } />
		<SelectInput label="Month" source="month" translateChoice={false} choices={[
			{ id: "1", name: "January" },
			{ id: "2", name: "February" },
			{ id: "3", name: "March" },
			{ id: "4", name: "April" },
			{ id: "5", name: "May" },
			{ id: "6", name: "June" },
			{ id: "7", name: "July" },
			{ id: "8", name: "August" },
			{ id: "9", name: "September" },
			{ id: "10", name: "October" },
			{ id: "11", name: "November" },
			{ id: "12", name: "December" },
		]} alwaysOn defaultValue={ monthNow() } />
    </Filter>
);

export const DealershipYearFilters = (props) => (
    <Filter {...props}>
		<ReferenceInput label="Dealership" source="dealership" reference="dealerships" alwaysOn allowEmpty={false} translateChoice={false} defaultValue={ getFirstDealership() }>
			<SelectInput/>
		</ReferenceInput>
		<SelectInput label="Year" source="year" translateChoice={false} defaultValue={ yearNow() } choices={[
			...years,
		]} alwaysOn />
    </Filter>
);

export const DealershipYearMonthFilters = (props) => (
    <Filter {...props}>
		<ReferenceInput label="Dealership" source="dealership" reference="dealerships" alwaysOn allowEmpty={false} translateChoice={false} defaultValue={ getFirstDealership() }>
			<SelectInput/>
		</ReferenceInput>
		<SelectInput label="Year" source="year" translateChoice={false} defaultValue={ yearNow() } choices={[
			...years,
		]} alwaysOn />
		<SelectInput label="Month" source="month" translateChoice={false} defaultValue={ monthNow() } choices={[
			{ id: "1", name: "January" },
			{ id: "2", name: "February" },
			{ id: "3", name: "March" },
			{ id: "4", name: "April" },
			{ id: "5", name: "May" },
			{ id: "6", name: "June" },
			{ id: "7", name: "July" },
			{ id: "8", name: "August" },
			{ id: "9", name: "September" },
			{ id: "10", name: "October" },
			{ id: "11", name: "November" },
			{ id: "12", name: "December" },
		]} alwaysOn />
    </Filter>
);

export const YearMonthFilters = (props) => (
    <Filter {...props}>
		<SelectInput label="Year" source="year" translateChoice={false} defaultValue={ yearNow() } choices={[
			...years,
		]} alwaysOn />
		<SelectInput label="Month" source="month" translateChoice={false} defaultValue={ monthNow() } choices={[
			{ id: "1", name: "January" },
			{ id: "2", name: "February" },
			{ id: "3", name: "March" },
			{ id: "4", name: "April" },
			{ id: "5", name: "May" },
			{ id: "6", name: "June" },
			{ id: "7", name: "July" },
			{ id: "8", name: "August" },
			{ id: "9", name: "September" },
			{ id: "10", name: "October" },
			{ id: "11", name: "November" },
			{ id: "12", name: "December" },
		]} alwaysOn />
    </Filter>
);

export const AccountFilters = (props) => (
    <Filter {...props}>
		<ReferenceInput label="Dealership" source="dealership" reference="dealerships" translateChoice={false} >
			<SelectInput/>
		</ReferenceInput>
		<ReferenceInput label="Bank" source="bank" reference="banks" translateChoice={false} >
			<SelectInput/>
		</ReferenceInput>
		<SelectInput label="Year" source="year" translateChoice={false} choices={[
			...years,
		]} alwaysOn/>
		<SelectInput label="Month" source="month" translateChoice={false} choices={[
			{ id: "1", name: "January" },
			{ id: "2", name: "February" },
			{ id: "3", name: "March" },
			{ id: "4", name: "April" },
			{ id: "5", name: "May" },
			{ id: "6", name: "June" },
			{ id: "7", name: "July" },
			{ id: "8", name: "August" },
			{ id: "9", name: "September" },
			{ id: "10", name: "October" },
			{ id: "11", name: "November" },
			{ id: "12", name: "December" },
		]} alwaysOn/>
		<SelectInput label="Filter Date By" source="filter_date_by" translateChoice={false} choices={[
			{ id: "release", name: "By Release Date" },
			{ id: "proceeds_collection", name: "By Proceeds Collection" },
			{ id: "di_collection", name: "By DI Collection" },
		]} alwaysOn/>
    </Filter>
);

export const AccountListFilters = (props) => (
    <Filter {...props}>
		<ReferenceInput label="Status" source="status_" reference="statuses">
			<SelectInput/>
		</ReferenceInput>
		<ReferenceInput label="Dealership" source="dealership" reference="dealerships" translateChoice={false} >
			<SelectInput/>
		</ReferenceInput>
		<ReferenceInput label="Bank" source="bank" reference="banks" translateChoice={false} >
			<SelectInput/>
		</ReferenceInput>
		<SelectInput label="Year" source="year" translateChoice={false} defaultValue={ yearNow() } choices={[
			...years,
		]} alwaysOn />
		<SelectInput label="Month" source="month" translateChoice={false} defaultValue={ monthNow() } choices={[
			{ id: "1", name: "January" },
			{ id: "2", name: "February" },
			{ id: "3", name: "March" },
			{ id: "4", name: "April" },
			{ id: "5", name: "May" },
			{ id: "6", name: "June" },
			{ id: "7", name: "July" },
			{ id: "8", name: "August" },
			{ id: "9", name: "September" },
			{ id: "10", name: "October" },
			{ id: "11", name: "November" },
			{ id: "12", name: "December" },
		]} alwaysOn />
    </Filter>
);

export const BankFilters = (props) => (
    <Filter {...props}>
		<ReferenceInput label="Bank" source="bank" reference="banks" translateChoice={false} alwaysOn>
			<SelectInput/>
		</ReferenceInput>
		<ReferenceInput label="Status" source="status_" reference="statuses" alwaysOn>
			<SelectInput/>
		</ReferenceInput>
    </Filter>
);

export const DocumentationPerformanceFilters = (props) => (
    <Filter {...props}>
		<ReferenceInput label="Dealership" source="dealership" reference="dealerships" translateChoice={false} alwaysOn>
			<SelectInput/>
		</ReferenceInput>
		<SelectInput label="Year" source="year" translateChoice={false} defaultValue={ yearNow() } choices={[
			...years,
		]} alwaysOn />
    </Filter>
);

export const NoDealershipYearMonthFilters = (props) => (
    <Filter {...props}>
		<ReferenceInput label="Dealership" source="dealership" reference="dealerships" alwaysOn translateChoice={false} >
			<SelectInput/>
		</ReferenceInput>
		<SelectInput label="Year" source="year" translateChoice={false} defaultValue={ yearNow() } choices={[
			...years,
		]} alwaysOn />
		<SelectInput label="Month" source="month" translateChoice={false} defaultValue={ monthNow() } choices={[
			{ id: "1", name: "January" },
			{ id: "2", name: "February" },
			{ id: "3", name: "March" },
			{ id: "4", name: "April" },
			{ id: "5", name: "May" },
			{ id: "6", name: "June" },
			{ id: "7", name: "July" },
			{ id: "8", name: "August" },
			{ id: "9", name: "September" },
			{ id: "10", name: "October" },
			{ id: "11", name: "November" },
			{ id: "12", name: "December" },
		]} alwaysOn />
    </Filter>
);



// WEBPACK FOOTER //
// ./src/reports/Filters.js